import React from 'react'

const SystemSettings = () => {
  return (
    <div>SystemSettings</div>
  )
}

export default SystemSettings